





























































































































































import {Serialize} from "cerialize";
import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";

import Client from "@/ts/interfaces/Client";

import Clients from "@/API/Clients";
import ErrorStore from "@/ts/stores/ErrorStore";
import SnackbarStore from "@/ts/stores/SnackbarStore";
import Package from "@/ts/interfaces/Package";
import AppPackages from "@/API/AppPackages";

@Component({
    components: {
        MainNavigation,
    }
})

export default class MandatesCreate extends Vue {
    valid = false;

    shortDescription = '';
    shortDescriptionRules = [
        (v: any) => v.length <= 10 || 'Kurzbezeichnung darf maximal 10 Zeichen lang sein'
    ];

    name = '';
    nameRules = [
        (v: any) => !!v || 'Firma oder Name wird benötigt'
    ];

    department = '';
    contactPerson = '';
    contactRules = [
        (v: any) => !!v || 'Ansprechpartner wird benötigt'
    ];
    functionContactPerson = '';
    phone = '';
    phoneRules = [
        (v: any) => !!v || 'Telefonnummer wird benötigt'
    ];

    mobilePhone = '';
    email = '';

    emailRules = [
        (v: any) => !!v || 'E-mail wird benötigt',
        (v: any) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Geben sie eine gültige E-mail ein'
    ];

    street = '';
    streetRules = [
        (v: any) => !!v || 'Straße wird benötigt'
    ];
    zip = '';
    zipRules = [
        (v: any) => !!v || 'Postleitzahl wird benötigt'
    ];
    city = '';
    cityRules = [
        (v: any) => !!v || 'Ort wird benötigt'
    ];

    spaceSizeLimit = 50;

    officeEnabled = false;
    offersEnabled = true;
    packageId = -1;

    orderNumber = '';
    ustID = '';

    packages: Package[] = [];
    appPackage: Package | null = null;

    get displayPackages() {
        return this.packages
    }

    //Lifecycle
    mounted() {
        AppPackages.getAppPackages().then(res => {
            this.packages = res;
        });

        //@ts-ignore:
        let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
        let packages = document.getElementById("icon-packages");
        let news = document.getElementById("icon-news");
        let settings = document.getElementById("icon-settings");

        //@ts-ignore:
        mandate.style = "color: #81B219";
        //@ts-ignore:
        packages.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        settings.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        news.style = "color: rgba(0, 0, 0, 0.54)";
    }

    //Methods/Functions
    clear() {
        ((this.$refs.form as HTMLFormElement).reset())
    };

    //Everything not provided here handles the server
    submitMandate() {
        ((this.$refs.form as HTMLFormElement).validate());
        if (this.$data.valid === true) {
            let client = new Client(0, this.name,
                this.shortDescription,
                this.department,
                this.contactPerson,
                this.functionContactPerson,
                this.phone,
                this.mobilePhone,
                this.email,
                this.street,
                this.zip,
                this.city,
                "",
                this.orderNumber,
                this.ustID,
                0,
                "",
                this.spaceSizeLimit,
                false,
                "",
                0,
                [],
                this.officeEnabled,
                this.offersEnabled,
                this.packageId
            );

            let serializedClient = Serialize(client);

            Clients.createClient(serializedClient).then(res => {
                this.$router.push("/mandates");
                SnackbarStore.show("Mandant erfolgreich angelegt")
            }).catch(err => {
                if (err.message && err.message.description) {
                    ErrorStore.showError(err.message.description)
                } else {
                    ErrorStore.showError("Serverfehler beim löschen")
                }
            });
        }
    }

    getPackage(appPackage: Package) {
        this.appPackage = appPackage;
        this.packageId = appPackage.id;
    }
}
